import { inicializarVueNoElemento } from '@App/VueHooks'

class ReflinksFrame extends HTMLElement {
    connectedCallback() {
        if (this.dataset.src) {
            if (this.dataset.lazy) {
                this.loadOnIntersection()
            } else {
                this.loadFromSrc()
            }
        }
    }

    loadOnIntersection() {
        let observer = new IntersectionObserver(
            entries => {
                if (this.loaded()) return

                entries.forEach(entry => {
                    if (entry.intersectionRatio >= 0.1) {
                        this.loadFromSrc()
                    }
                })
            },
            {
                threshold: 1.0,
            }
        )

        observer.observe(this)
    }

    async loadFromSrc() {
        if (this.loaded()) return
        this.dataset.loaded = 'true'

        let src = this.dataset.src.replace(/\&amp;/g, '&')

        let { data } = await axios.get(src, { headers: { Accept: 'text/html' } })

        let doc = document.createElement('html')
        doc.innerHTML = data

        let framePluckedFromResponse = doc.querySelector(`reflinks-frame[data-id="${this.dataset.id}"]`)

        this.innerHTML = ''

        let childNodes = Array.from(framePluckedFromResponse.childNodes)
        for (let i = 0; i < childNodes.length; i++) {
            this.appendChild(childNodes[i])
        }

        inicializarVueNoElemento(this)
    }

    loaded() {
        return this.dataset.loaded != null
    }
}

if (!window.customElements.get('reflinks-frame')) {
    window.customElements.define('reflinks-frame', ReflinksFrame)
}
